var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6487 16.6862L16.1183 15.2308V9.58974C16.1183 6.12615 14.1727 3.22667 10.7797 2.45949V1.69231C10.7797 0.755897 9.98487 0 9.0002 0C8.01553 0 7.22068 0.755897 7.22068 1.69231V2.45949C3.81586 3.22667 1.88211 6.11487 1.88211 9.58974V15.2308L0.351725 16.6862C-0.395674 17.3969 0.126319 18.6154 1.18217 18.6154H16.8064C17.8741 18.6154 18.3961 17.3969 17.6487 16.6862ZM13.7456 16.359H4.25481V9.58974C4.25481 6.7918 6.0462 4.51282 9.0002 4.51282C11.9542 4.51282 13.7456 6.7918 13.7456 9.58974V16.359ZM9.0002 22C10.3052 22 11.3729 20.9846 11.3729 19.7436H6.62751C6.62751 20.9846 7.68336 22 9.0002 22Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.647430c1fc43debbf9cd6bfd01e85c07.svg";
export { ForwardRef as ReactComponent };